"use client";

import { Search } from "lucide-react";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  testId?: string;
}

export function WalletSearchBar({
  value,
  onChange,
  placeholder = "Search by booking number and flight",
  testId = "search-input",
}: Readonly<SearchBarProps>) {
  return (
    <div className="mt-6">
      <div className="relative">
        <Search
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
          aria-hidden="true"
        />
        <input
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-200 bg-white pl-9 pr-4 py-2.5 text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-turquoise focus:border-transparent transition [&::-webkit-search-cancel-button]:cursor-pointer"
          data-testid={testId}
        />
      </div>
    </div>
  );
}
